import React from "react";

import { FileText } from "lucide-react";

import { Button } from "~/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/ui/table";
import StatusBadge from "~/pages/clients/components/client-detail/StatusBadge";
import { PurchaseOrder } from "~/types/user";
import { formatCurrency, formatDate } from "~/utils/helpers";

interface PendingPaymentsSectionProps {
  orders: PurchaseOrder[];
  onViewOrder: (orderId: string) => void;
}

export const PendingPaymentsSection: React.FC<PendingPaymentsSectionProps> = ({
  orders,
  onViewOrder,
}) => {
  if (orders.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 className="mb-3 text-base font-semibold">Pagos Pendientes</h3>
      <div className="overflow-hidden rounded-md border">
        <Table>
          <TableHeader className="bg-muted/50">
            <TableRow>
              <TableHead>Fecha</TableHead>
              <TableHead>ID de Nota</TableHead>
              <TableHead>Estado</TableHead>
              <TableHead className="text-right">Monto</TableHead>
              <TableHead className="text-right">Acciones</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.map((order, index) => (
              <TableRow
                key={order.id}
                className="duration-300 animate-in fade-in-0 slide-in-from-top-1 fill-mode-both hover:bg-muted/30"
                style={{ animationDelay: `${Math.min(index * 40, 400)}ms` }}
              >
                <TableCell>{formatDate(order.createdAt)}</TableCell>
                <TableCell>{order.id}</TableCell>
                <TableCell>
                  <StatusBadge status={order.paymentStatus} type="payment" />
                </TableCell>
                <TableCell className="text-right font-medium">
                  {formatCurrency(order.total)}
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onViewOrder(order.id)}
                  >
                    <FileText className="mr-2 h-4 w-4" />
                    Ver nota de venta
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
